import { Home, CreditCard, Send, TrendingUp, RefreshCw, User, Award } from 'react-feather';
import { FaEthereum } from 'react-icons/fa';

export const NAV_ITEMS = [
    // ── MAIN ─────────────────────────────────────
    {
        group: 'Main',
        id: 'home',
        label: 'Dashboard',
        Icon: Home,
    },
    {
        group: null,
        id: 'accounts',
        label: 'My Account',
        Icon: User,
    },
    {
        group: null,
        id: 'transfer',
        label: 'Payments',
        Icon: Send,
    },
    {
        group: 'Partners',
        id: 'partner',
        label: 'Partner Dashboard',
        Icon: Award,
    },
    // ── COMING SOON ───────────────────────────────
    {
        group: 'Coming Soon',
        id: 'fx',
        label: 'FX Exchange',
        Icon: RefreshCw,
        comingSoon: true,
        sections: [],
    },
    {
        group: null,
        id: 'crypto',
        label: 'Crypto OTC',
        Icon: FaEthereum,
        comingSoon: true,
        sections: [],
    },
    {
        group: null,
        id: 'investments',
        label: 'Investments',
        Icon: TrendingUp,
        comingSoon: true,
        sections: [],
    },
    {
        group: null,
        id: 'cards',
        label: 'Cards',
        Icon: CreditCard,
        comingSoon: true,
        sections: [],
    },
];
